module.exports = __webpack_public_path__ + "static/logo-sheyla-blanco-ad72b811bec90c637634eb89d779e0c3.png";